import { render, staticRenderFns } from "./AppPluginsandRoutes.vue?vue&type=template&id=3fabf96a&"
import script from "./AppPluginsandRoutes.vue?vue&type=script&lang=js&"
export * from "./AppPluginsandRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports